import { Component, OnInit, Input, OnDestroy } from '@angular/core'
import { CheckoutService } from '../../checkout.service'
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms'
import { Observable, of, Subscription } from 'rxjs'
import {
  User,
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { Router } from '@angular/router'
import { switchMap } from 'rxjs/operators'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { CommonService } from '../../../../../../shared/services/common.service'
import { QuoteDataService } from '../../../../../quote/quote-checkout/services/quote-data.service'
import { environment } from '../../../../../../../environments/environment'

@Component({
  standalone: false,
  selector: 'vs-shiping-details',
  templateUrl: './shiping-details.component.html',
  styleUrls: ['./shiping-details.component.scss'],
})
export class ShipingDetailsComponent implements OnInit, OnDestroy {
  cartId$: Observable<string> = this.activeCartService.getActiveCartId()
  @Input() isProceedToCheckout: boolean
  //@Input() isUserSapBlocked?: boolean

  shipToAddress: FormGroup
  countryNames: any
  selectedCountry: any
  countryRegionNames: any
  isSoldToAddress: false
  company: string
  userType: string
  user$: Observable<User>
  isLoggedinUser = false
  cartId: string
  isSelectAddress = false
  isSubmitted = false
  userAddressData: any
  cartName = 'vscart'
  userAddressData$: Observable<any>
  componentAddress = 'Ship To'

  public radioSelected: string
  public newAdd: boolean
  public userRoles: string = 'userRoles'
  public term: string
  public selectedAddress

  userAddressList: any
  selectedShipAddress: {
    firstName: any
    lastName: any
    companyName: any
    line1: any
    town: any
    name: any
    postalCode: any
  }
  selectedState: any
  activeCart: any
  activeCartIdSubscription: Subscription
  activeCartIdSubscriptionForAddress: Subscription

  constructor(
    public activeCartService: ActiveCartFacade,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private data: QuoteDataService,
    private auth: AuthService,

    private router: Router,
    private checkoutService: CheckoutService,
    private globalMessageService: GlobalMessageService,
    private userAccountFacade: UserAccountFacade
  ) {
    this.activeCartIdSubscription = this.cartId$.subscribe(
      (data) => {
        this.cartId = data
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  ngOnDestroy(): void {
    if (this.activeCartIdSubscriptionForAddress) {
      this.activeCartIdSubscriptionForAddress.unsubscribe()
    }
    if (this.activeCartIdSubscription) {
      this.activeCartIdSubscription.unsubscribe()
    }
  }

  ngOnInit(): void {
    this.data.recieveSubmittedFlags.subscribe(
      (data) => {
        this.isSubmitted = data
        if (data) {
          this.shipToAddress.setErrors({ incorrect: true })
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        if (success) {
          this.isLoggedinUser = success
          this.userType = 'current'
        } else {
          this.userType = 'anonymous'
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.shipToAddressFormDetails()
    this.data.recieveShipToAddress.subscribe(
      (isChecked) => {
        if (isChecked) {
          this.data.setShipToAddressData(this.shipToAddress.value)
        } else {
          this.data.setShipToAddressData(null)
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.shipToAddress.valueChanges.subscribe(
      (data) => {
        this.data.setShipToAddressData(data)
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  shipToAddressFormDetails() {
    this.shipToAddress = this.formBuilder.group({
      companyName: new FormControl('', Validators.required),
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      country: new FormControl('Select Country', Validators.required),
      state: new FormControl('Select State/Province', Validators.required),
      city: new FormControl('', Validators.required),
      zip: new FormControl('', Validators.required),
    })
    this.getCountryData()
    // this.getUserAddressList();
    this.saveCountryData()
    this.getUserAddress()
  }
  get companyName() {
    return this.shipToAddress.get('companyName')
  }
  get addressLine1() {
    return this.shipToAddress.get('addressLine1')
  }
  get country() {
    return this.shipToAddress.get('country')
  }
  get state() {
    return this.shipToAddress.get('state')
  }
  get city() {
    return this.shipToAddress.get('city')
  }
  get zip() {
    return this.shipToAddress.get('zip')
  }
  soldToAddress() {
    this.data.sendCheckBox(this.isSoldToAddress)
    if (this.isSoldToAddress) {
      this.data.getSoldToAddressData().subscribe(
        (data) => {
          if (data) {
            if (data.country) {
              const regions = 'regions'
              this.commonService
                .getData(
                  environment.occBaseUrl +
                    environment.getCountryURL +
                    data.country +
                    '/regions?fields=DEFAULT'
                )
                .subscribe(
                  (success) => {
                    this.countryRegionNames = success[regions]
                  },
                  (error) => {
                    this.globalMessageService.add(
                      error,
                      GlobalMessageType.MSG_TYPE_ERROR,
                      5000
                    )
                    window.scrollTo(0, 0)
                  }
                )
            }
            this.shipToAddress.patchValue(data)
            this.shipToAddress.controls['state'].setValue(data.state)
            this.selectedState = data.state
          }
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
    } else {
      this.shipToAddress.controls['companyName'].setValue('')
      this.shipToAddress.controls['addressLine1'].setValue('')
      this.shipToAddress.controls['addressLine2'].setValue('')
      this.shipToAddress.controls['country'].setValue('')
      this.shipToAddress.controls['state'].setValue('')
      this.shipToAddress.controls['city'].setValue('')
      this.shipToAddress.controls['zip'].setValue('')
    }
  }
  getCountryData() {
    const countries = 'countries'
    const urlParam = [countries]
    const apiUrl = this.commonService.constructUrl(urlParam)
    const apiParams = { fields: 'DEFAULT', type: 'SHIPPING' }

    this.commonService.getData(apiUrl, apiParams).subscribe(
      (success) => {
        this.countryNames = success[countries]
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  saveCountryData() {
    this.selectedCountry = this.shipToAddress.controls['country'].value
    const regions = 'regions'
    this.commonService
      .getData(
        environment.occBaseUrl +
          environment.getCountryURL +
          this.selectedCountry +
          '/regions?fields=DEFAULT'
      )
      .subscribe(
        (success) => {
          this.countryRegionNames = success[regions]
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  addAddress() {
    this.newAdd = true
  }
  selectedAdd(event) {
    // if(event.componentAddress === this.componentAddress){
    this.selectedAddress = event
    this.data.sendLoggedinShipToAddress(this.selectedAddress)
    this.checkoutService.deliveryAddressData.next(this.selectedAddress)
    this.closeForm(false)
    // }
  }
  closeForm(event) {
    // if (event.componentAddress === this.componentAddress) {
    this.isSelectAddress = event
    //  }
  }

  getUserAddress() {
    this.activeCartIdSubscriptionForAddress =
      this.checkoutService.getCartIdResponse.subscribe(
        (id) => {
          if (id) {
            this.cartId = id
            this.userAddressData$ = this.checkoutService.getCartServerResponse
            this.userAddressData$.subscribe(
              (data) => {
                this.userAddressData = data
                this.selectedAddress = this.userAddressData?.deliveryAddress
                this.data.sendLoggedinShipToAddress(this.selectedAddress)
                this.checkoutService.deliveryAddressData.next(
                  this.userAddressData.deliveryAddress
                )
                // this.checkoutService.billToAddressData.next(
                //   this.userAddressData.billToAddress
                // );
              },
              (error) => {
                // this.globalMessageService.add(
                //   error,
                //   GlobalMessageType.MSG_TYPE_ERROR,
                //   5000
                // );
                window.scrollTo(0, 0)
              }
            )
          }
        },
        (error) => {
          // this.globalMessageService.add(
          //   error,
          //   GlobalMessageType.MSG_TYPE_ERROR,
          //   5000
          // );
          window.scrollTo(0, 0)
        }
      )
  }
  selectAddress() {
    this.isSelectAddress = true
  }
  closeAdd(flag) {
    this.isSelectAddress = flag
  }
}
